import { Routes, Route, useLocation } from "react-router-dom";
import PageNavigation from "../components/pageNavigation/PageNavigation";
import { routes } from "./routes";

import styles from "./AppRouter.module.css";

const Layout = ({ children }) => {
  const location = useLocation();

  const currentRoute = routes.find((route) => route.path === location.pathname);

  var showNavigation = !currentRoute?.hideNavigation;
  showNavigation = false;

  return (
    <div className={styles.wraper}>
      {children}
      {showNavigation && <PageNavigation className={styles.pageNavigation} />}
    </div>
  );
};

const AppRouter = () => {
  return (
    <Routes>
      {routes.map(({ path, element }) => (
        <Route key={path} path={path} element={<Layout>{element}</Layout>} />
      ))}
    </Routes>
  );
};

export default AppRouter;
